export const MEMBER_EDIT_REQUEST = 'MEMBER_EDIT_REQUEST'
export const MEMBER_EDIT_SUCCESS = 'MEMBER_EDIT_SUCCESS'
export const MEMBER_EDIT_FAIL = 'MEMBER_EDIT_FAIL'
export const MEMBER_EDIT_CLEAR = 'MEMBER_EDIT_CLEAR'

export const MEMBER_CREATE_REQUEST = 'MEMBER_CREATE_REQUEST'
export const MEMBER_CREATE_SUCCESS = 'MEMBER_CREATE_SUCCESS'
export const MEMBER_CREATE_FAIL = 'MEMBER_CREATE_FAIL'
export const MEMBER_CREATE_CLEAR = 'MEMBER_CREATE_CLEAR'

export const MEMBER_ADD_RELATIVES_REQUEST = 'MEMBER_ADD_RELATIVES_REQUEST'
export const MEMBER_ADD_RELATIVES_SUCCESS = 'MEMBER_ADD_RELATIVES_SUCCESS'
export const MEMBER_ADD_RELATIVES_FAIL = 'MEMBER_ADD_RELATIVES_FAIL'
export const MEMBER_ADD_RELATIVES_CLEAR = 'MEMBER_ADD_RELATIVES_CLEAR'

export const MEMBER_UPDATE_RELATIVES_REQUEST = 'MEMBER_UPDATE_RELATIVES_REQUEST'
export const MEMBER_UPDATE_RELATIVES_SUCCESS = 'MEMBER_UPDATE_RELATIVES_SUCCESS'
export const MEMBER_UPDATE_RELATIVES_FAIL = 'MEMBER_UPDATE_RELATIVES_FAIL'
export const MEMBER_HIDE_WIFE_NAME_REQUEST = 'MEMBER_HIDE_WIFE_NAME_REQUEST'
export const MEMBER_HIDE_WIFE_NAME_SUCCESS = 'MEMBER_HIDE_WIFE_NAME_SUCCESS'
export const MEMBER_HIDE_WIFE_NAME_FAIL = 'MEMBER_HIDE_WIFE_NAME_FAIL'

export const MEMBER_DELETE_RELATIVES_REQUEST = 'MEMBER_DELETE_RELATIVES_REQUEST'
export const MEMBER_DELETE_RELATIVES_SUCCESS = 'MEMBER_DELETE_RELATIVES_SUCCESS'
export const MEMBER_DELETE_RELATIVES_FAIL = 'MEMBER_DELETE_RELATIVES_FAIL'
export const MEMBER_DELETE_RELATIVES_CLEAR = 'MEMBER_DELETE_RELATIVES_CLEAR'

export const MEMBER_GENERATE_CSV_REQUEST = 'MEMBER_GENERATE_CSV_REQUEST'
export const MEMBER_GENERATE_CSV_SUCCESS = 'MEMBER_GENERATE_CSV_SUCCESS'
export const MEMBER_GENERATE_CSV_FAIL = 'MEMBER_GENERATE_CSV_FAIL'
export const MEMBER_GENERATE_CSV_CLEAR = 'MEMBER_GENERATE_CSV_CLEAR'

export const MEMBER_GENERATE_DATA_REQUEST = 'MEMBER_GENERATE_DATA_REQUEST'
export const MEMBER_GENERATE_DATA_SUCCESS = 'MEMBER_GENERATE_DATA_SUCCESS'
export const MEMBER_GENERATE_DATA_FAIL = 'MEMBER_GENERATE_DATA_FAIL'

export const MEMBER_INFO_REQUEST = 'MEMBER_INFO_REQUEST'
export const MEMBER_INFO_SUCCESS = 'MEMBER_INFO_SUCCESS'
export const MEMBER_INFO_FAIL = 'MEMBER_INFO_FAIL'

export const MEMBER_UPLOAD_AVATAR_REQUEST = 'MEMBER_UPLOAD_AVATAR_REQUEST'
export const MEMBER_UPLOAD_AVATAR_SUCCESS = 'MEMBER_UPLOAD_AVATAR_SUCCESS'
export const MEMBER_UPLOAD_AVATAR_FAIL = 'MEMBER_UPLOAD_AVATAR_FAIL'

export const MEMBER_ALL_REQUEST = 'MEMBER_ALL_REQUEST'
export const MEMBER_ALL_SUCCESS = 'MEMBER_ALL_SUCCESS'
export const MEMBER_ALL_FAIL    = 'MEMBER_ALL_FAIL'

export const EXPORT_SVG_REQUEST = 'EXPORT_SVG_REQUEST'
export const EXPORT_SVG_SUCCESS = 'EXPORT_SVG_SUCCESS'
export const EXPORT_SVG_FAIL    = 'EXPORT_SVG_FAIL'
export const EXPORT_SVG_CLEAR    = 'EXPORT_SVG_CLEAR'

export const MEMBER_SEARCH_BY_NAME_REQUEST = 'MEMBER_SEARCH_BY_NAME_REQUEST'
export const MEMBER_SEARCH_BY_NAME_SUCCESS = 'MEMBER_SEARCH_BY_NAME_SUCCESS'
export const MEMBER_SEARCH_BY_NAME_FAIL = 'MEMBER_SEARCH_BY_NAME_FAIL'

export const MEMBER_DELETE_REQUEST = 'MEMBER_DELETE_REQUEST'
export const MEMBER_DELETE_SUCCESS = 'MEMBER_DELETE_SUCCESS'
export const MEMBER_DELETE_FAIL = 'MEMBER_DELETE_FAIL'
export const MEMBER_DELETE_CLEAR = 'MEMBER_DELETE_CLEAR'
